import { ReactElement, ReactNode, useState } from "react";
import { Button } from "./button/Button";

interface ConfirmPopupProps {
  title: string;
  message: string | ReactElement | ReactNode;
  confirmAction: (title: string, id: number) => void | Promise<void>;
  closeAction: () => void;
  id: number;
  bodyStyle?: any;
  footerStyle?: any;
}

const ConfirmPopup = ({
  title,
  message,
  confirmAction,
  closeAction,
  id,
  footerStyle = {},
  bodyStyle = {},
}: ConfirmPopupProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onConfirm = async () => {
    if (isSubmitting) {
      return;
    }
    setIsSubmitting(true);
    try {
      await Promise.resolve(confirmAction(title, id));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="app-dialog-container">
      <div className="dialog-container dialog-box-min filter-box">
        <div className="dialog-header" style={{ border: "none" }}></div>
        <div className="dialog-title">
          <h3>{title}</h3>
        </div>
        <div className="dialog-body" style={bodyStyle}>
          <div className="input-group">{message}</div>
        </div>
        <div className="dialog-footer" style={footerStyle}>
          <div className="apply-cancel">
            <Button
              color="primary"
              className="btn md"
              variant="solid"
              id="btn-apply"
              onClick={onConfirm}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Processing..." : "Confirm"}
            </Button>
            <Button
              color="primary"
              className="btn md"
              variant="outline"
              id="btn-close"
              onClick={closeAction}
              disabled={isSubmitting}
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmPopup;
